exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".unit-vpn-logs .download[data-v-77fa833b]{margin:0 0 10px 0}", ""]);

